<template>
  <div class="transfer-groups">
    <div
      v-for="(transfers, index) in groups"
      :key="index"
      class="transfer-group"
    >
      <div class="tooltip-wrapper">
        <kw-tooltip :options="tooltipOptions">
          <div class="group-name">
            <img
              :src="require(`../../assets/svg/${getIconName(transfers[0])}.svg`)"
              :class="['group-img', getClassName(transfers[0])]"
            >
            <span class="vehicle-name">
              {{ getGroupNameSplitedBySpaces(transfers[0])[0] }}
              <span style="white-space: nowrap;">
                {{ getGroupNameSplitedBySpaces(transfers[0])[1] }}
                <span class="icon-info" />
              </span>
            </span>
          </div>
          <span
            slot="content"
            class="description"
          >
            <b>{{ getGroupName(transfers[0]) }}</b> -
            {{ getGroupDescription(transfers[0]) }}
          </span>
        </kw-tooltip>
      </div>
      <div class="transfer-list">
        <moz-transfer-card
          v-for="(item, innerIndex) in transfers"
          :key="innerIndex"
          v-bind="$attrs"
          :card="item"
          :locale="locale"
        />
      </div>
    </div>
  </div>
</template>

<script>
import KwTooltip from '@kiwitaxi/vue-components/dist/KwTooltip';

import MozTransferCard from './MozTransferCard.vue';

const ICON_MAP = {
  2: 'shuttle',
  3: 'car',
  4: 'suv',
  5: 'limousine',
  6: 'bus',
  8: 'car',
  9: 'taxi',
  11: 'taxi',
  13: 'moto',
  16: 'boat',
  18: 'boat',
  20: 'helicopter',
  102: 'shuttle',
  103: 'car',
  104: 'suv',
  105: 'limousine',
  106: 'bus',
  107: 'taxi',
  109: 'boat',
  110: 'car',
};

const TABLEX_MAX_WIDTH = 768;

const startWithLowerCase = ([first, ...other]) => `${first.toLowerCase()}${other.join('')}`;

export default {
  name: 'Group',
  components: {
    MozTransferCard,
    KwTooltip,
  },
  props: {
    groups: {
      type: Array,
      required: false,
      default: () => [],
    },
    locale: {
      type: String,
      required: false,
      default: 'en',
    },
    vehicleTexts: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      tooltipOptions: {
        interactive: true,
        placement: 'right',
        offset: '10, 10',
      },
    };
  },
  mounted() {
    window.addEventListener('resize', this.onResizeHandler);
    this.onResizeHandler();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResizeHandler);
  },
  methods: {
    getGroupName(transfer) {
      const { key = '' } = transfer.vehicle.vehicle_type;
      return this.vehicleTexts[key].display_name;
    },
    getGroupNameSplitedBySpaces(transfer) {
      const [firstWord, ...lastWords] = this.getGroupName(transfer).split(' ');
      return [firstWord, lastWords.join(' ')];
    },
    getGroupDescription(transfer) {
      const { key = '' } = transfer.vehicle.vehicle_type;
      const text = this.vehicleTexts[key].description;
      return startWithLowerCase(text);
    },
    getClassName(transfer) {
      const { key } = transfer.vehicle.vehicle_type;
      return `group-img--${ICON_MAP[key]}`;
    },
    getIconName(transfer) {
      const { key } = transfer.vehicle.vehicle_type;
      return ICON_MAP[key];
    },
    onResizeHandler() {
      const { innerWidth } = window;
      if (innerWidth > TABLEX_MAX_WIDTH && this.tooltipOptions.placement !== 'right') {
        this.tooltipOptions = {
          ...this.tooltipOptions,
          placement: 'right',
        };
      }
      if (innerWidth <= TABLEX_MAX_WIDTH && this.tooltipOptions.placement !== 'bottom') {
        this.tooltipOptions = {
          ...this.tooltipOptions,
          placement: 'bottom',
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@kiwitaxi/vue-components/dist/styles/KwTooltip.css';

  .transfer-groups {
    >div:not(:last-child) {
      margin-bottom: 63px;
      @media screen and (min-width: $tablet-width) {
        margin-bottom: 47px;
      }
      @media screen and (min-width: $tablet-width) {
        margin-bottom: 63px;
      }
    }
  }

  .tooltip-wrapper {
    text-align: center;
    @media screen and (min-width: $tablet-width) {
      text-align: left;
    }

    .kw-tooltip {
      margin-bottom: 34px;
      outline: none;
      @media screen and (min-width: $tablet-width) {
        margin-bottom: 24px;
      }
    }
  }


  .transfer-list {
    >div:not(:last-child) {
      margin-bottom: 16px;
    }
  }

  .group-name {
    font-size: 24px;
    font-weight: 600;
    line-height: 1.17;
    color: $primary;
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (min-width: $tablet-width) {
      justify-content: initial;
    }

    .vehicle-name {
      margin-right: 10px;
    }

    .description {
      font-size: 14px;
      line-height: 1.86;
      color: #444;
    }

    .icon-info {
      display: inline-block;
      background-size: contain;
      background-repeat: no-repeat;
      width: 18px;
      height: 18px;
      cursor: pointer;
      line-height: 40px;
      vertical-align: middle;
      background-image: url('../../assets/svg/icon_info.svg');
    }

    .group-img {
      height: 24px;
      width: auto;
      margin-right: 10px;

      &--shuttle {
        height: 36px;
      }
    }

  }
</style>
